export function isProject(__typename: string) {
  return __typename === 'Project';
}
